import {post,get,delet,put} from '../axios/request';
import delay from "../helper/delay";
//获取交易记录列表
export function getLogList(data){
    return post('/r/Manage_OperationLog/getLogList',data)
}
//获取日志操作类型
export function getOpType(data){
    return get('/r/Manage_OperationLog/getOpType',data)
}